import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useAuth } from '../../contexts/AuthContext';
import { useInView, reveal } from './motion';
import InkFlourish from './InkFlourish';
import { useT } from '../../i18n/LanguageContext';

export default function CtaBanner() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { ref, visible } = useInView();
  const t = useT();

  return (
    <Box sx={{ bgcolor: 'transparent', py: { xs: 6, md: 9 }, px: { xs: 3, md: 5 } }}>
      <Box
        ref={ref}
        sx={{
          maxWidth: theme.home.maxWidth, mx: 'auto', borderRadius: 6, overflow: 'hidden', position: 'relative',
          background: `linear-gradient(120deg, ${theme.home.ink}, #20303a)`,
          px: { xs: 4, md: 9 }, py: { xs: 7, md: 10 }, textAlign: 'center',
          ...reveal(visible),
        }}>
        <Box sx={{ position: 'absolute', top: -120, right: -80, width: 360, height: 360, borderRadius: '50%',
          background: `radial-gradient(circle, ${theme.home.coral}44, transparent 65%)` }} />
        <Box sx={{ position: 'absolute', bottom: -140, left: -100, width: 360, height: 360, borderRadius: '50%',
          background: `radial-gradient(circle, ${theme.home.cyan}40, transparent 68%)` }} />

        <Typography variant="h2" sx={{
          position: 'relative', color: theme.home.paper, fontSize: { xs: '2.1rem', md: '3.2rem' }, maxWidth: 720, mx: 'auto',
        }}>
          {t('home.ctaBanner.title')}
        </Typography>
        <Typography sx={{ position: 'relative', mt: 2.5, color: 'rgba(251,248,244,0.75)', fontSize: '1.15rem', maxWidth: 540, mx: 'auto' }}>
          {t('home.ctaBanner.body')}
        </Typography>
        <Button
          variant="contained" size="large" endIcon={<ArrowForwardIcon />}
          onClick={() => navigate(currentUser ? '/dashboard' : '/signup')}
          sx={{ position: 'relative', mt: 4.5, px: 4, py: 1.6, borderRadius: 999, fontSize: '1.05rem',
            bgcolor: theme.home.coralText, '&:hover': { bgcolor: theme.home.coralHover } }}
        >
          {t('home.ctaBanner.cta')}
        </Button>
        <InkFlourish />
      </Box>
    </Box>
  );
}
